import { colorsPalettes, mixins } from "@similarweb/styles";
import styled from "styled-components";

export const StyledHeaderCell = styled.div`
    width: 100%;
`;

export const StyledHeaderCellText = styled.span`
    ${mixins.setFontVariant("drilldown", colorsPalettes.carbon[400])};
    ${mixins.truncateText()};
`;
